/** Collapse empty paragraphs that inflate spacing on the public story reader. */
export function normalizeStoryParagraphHtml(html) {
  return String(html || "")
    .replace(/<\/p>\s*<p><br\s*\/?><\/p>\s*<p>/gi, "</p><p>")
    .replace(/<\/p>\s*<p>\s*<\/p>\s*<p>/gi, "</p><p>");
}
